///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'kb-label',
    templateUrl: './label.component.html',
})
export class KbLabelComponent {
    @ViewChild('label')
    public label: ElementRef;
    @Input()
    public config: any;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/label/label.component.ts